module.exports = {
  title1: '36px',
  title2: '18px',
  title3: '14px',
  title4: '12px'
}